import React from 'react';
import { useSelector } from 'react-redux';
import authSelectors from 'src/modules/auth/authSelectors';

interface DemoRedactProps {
  children: React.ReactNode;
  className?: string;
}

function DemoRedact({ children, className = '' }: DemoRedactProps) {
  const currentUser = useSelector(authSelectors.selectCurrentUser);
  const isDemo = currentUser?.permissions?.isDemo;

  return (
    <span className={`${className} ${isDemo ? 'blur-md select-none' : ''}`}>
      {children}
    </span>
  );
}

export default DemoRedact;
